interface MissingApplicationSettingsBadgeProps {
  count: number;
}

export function MissingApplicationSettingsBadge({
  count,
}: MissingApplicationSettingsBadgeProps) {
  if (count > 0) {
    return (
      <p className="text-amber-700 bg-amber-50 ring-amber-600/20 mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset">
        {count} Missing {`setting${count > 1 ? "s" : ""}`}
      </p>
    );
  } else {
    return <></>;
  }
}
